import React from 'react';

function PolitiqueDeConfidentialite() {
    return (
        <div>Politique de confidentialité</div>
    );
}

export default PolitiqueDeConfidentialite;
